<template>
  <div>
    <layout-header title="Registro de Servicios" />
    <ets-page v-if="isAllowed">
      <ets-spinner v-if="isClientsLoading" />
      <ets-table v-if="services.length > 0 && !isClientsLoading" :columns="columns" :data="services" class="condensed" :fill="true">
        <template slot="row" slot-scope="service" v-if="isAllowed">
          <td>{{ service.row.clientName }}</td>
          <td>{{ service.row.classification }}</td>
          <td>{{ service.row.segmentName }}</td>
          <td>{{ service.row.name }}</td>
          <td>{{ service.row.serviceType }}</td>
          <td v-if="service.row.beginDate" class="number">{{ service.row.beginDate | etsdate }}</td>
          <td v-if="!service.row.beginDate" class="number">{{ service.row.beginDate }}</td>
        </template>
      </ets-table>
    </ets-page>
    <forbidden v-else />
  </div>
</template>

<script>
import { mapState } from "vuex";
import LayoutHeader from "@/components/Layout/LayoutHeader";
import compliance from "@/logic/api/compliance";
import Forbidden from "@/components/Forbidden";
export default {
  name: "PageServices",
  components: {
    LayoutHeader,
    Forbidden
  },
  data: () => ({
    services: [],
    isClientsLoading: false
  }),
  computed: {
    ...mapState(["userPermissions"]),
    columns() {
      return [
        { text: "Nombre cliente", key: "clientName" },
        { text: "Clasificación", key: "classification" },
        { text: "Segmento", key: "segmentName" },
        { text: "Nombre servicio", key: "name" },
        { text: "Tipo servicio", key: "serviceType" },
        { text: "Fecha de Inicio", class: "number", key: "beginDate" }
      ];
    },
    isAllowed() {
      return this.userPermissions && this.userPermissions.login;
    }
  },
  methods: {
    async getServices() {
      this.isClientsLoading = true;
      const responseClients = await compliance.getClients();
      const responseSegments = await compliance.getSegments();

      const clientsInfo = responseClients.data.map(client => {
        const segment = responseSegments.data.find(s => s.segmentId === client.segmentId);
        return { ...client, segmentName: segment ? segment.name : null };
      });

      const responseServices = await compliance.getServices();
      const servicesInfo = responseServices.data.map(service => {
        const client = clientsInfo.find(client => client.clientId === service.clientId);
        const profile = client.profiles.find(x => x.endDate === null);
        return {
          ...service,
          clientName: client ? client.name : null,
          segmentName: client ? client.segmentName : null,
          classification: profile ? profile.classification : "-"
        };
      });
      this.services = servicesInfo.filter(x => !x.endDate).sort((a, b) => a.name - b.name);
      this.isClientsLoading = false;
    }
  },
  created() {
    this.getServices();
  }
};
</script>
